/*
 * decaffeinate suggestions:
 * DS102: Remove unnecessary code created because of implicit returns
 * Full docs: https://github.com/decaffeinate/decaffeinate/blob/main/docs/suggestions.md
 */
if (!window.Utility) { window.Utility = {}; }

Utility.Voice = class Voice {
  static readText(text) {
    if (typeof window.JsInterface === 'undefined') { return; }
    return JsInterface.readText(text);
  }
};
